import React from "react";
import {Control} from "react-hook-form/dist/types";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {Controller, FieldPath} from "react-hook-form";
import {ComuneRecord} from "@commons/mapping/ComuneRecord";
import {useGetComuniQuery} from "@commons/features/sistema/ComuniEProv.api";
import ComboBox from "./ComboBox";

export const ComboBoxComuni: React.FC<{ control: Control<AziendaRecord>, name: FieldPath<AziendaRecord>, defaultValue: ComuneRecord | null, siglaProv: string }> = ({
                                                                                                                                                      control,
                                                                                                                                                      name,
                                                                                                                                                      defaultValue,
                                                                                                                                                      siglaProv
                                                                                                                                                  }) => {
    const {data, isLoading} = useGetComuniQuery({siglaProv}, {skip: !siglaProv});
    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<ComuneRecord> label={'Comune'} value={value} onChange={onChange} fieldState={fieldState}
                                                       data={data}
                                                       isLoading={isLoading}

                                                       searchablePropsName={['descrizione']}
                                                       isSameFn={(a, z) => (a && z) ? a.codComune === z.codComune : false}
                                                       keyValueFn={(v) => v.codComune!}
                                                       displayValueFn={(v) => data && v ? v.descrizione! + ' (' + v.codComune + ')' : ''}
                               />
                           )
                       }}
    />
}
export default ComboBoxComuni;